/* Studio Lostit — read-only Square wishlist visual state mirror.
   DOES NOT handle clicks, save lists or replace app buttons. Vendor controls
   retain their own listeners and wishlist state; this only reflects them. */
(() => {
 'use strict';
 const host=document.querySelector('.sls-design-page__grid');
 if(!host||host.dataset.slsHeartVisualReady==='1')return;
 host.dataset.slsHeartVisualReady='1';
 const selector='.sls-design-page__card button,.sls-design-page__card [role="button"],.sls-design-page__wishlist a';
 const savedText=/\b(remove from (?:my )?wishlist|remove from favourites|remove from favorites|saved|wishlisted|added to wishlist|in (?:your|my) wishlist)\b/i;
 function refresh(){
   host.querySelectorAll(selector).forEach(control=>{
     // Square state should never be mirrored onto Shopify Add to Cart controls.
     if(control.closest('.sls-design-page__quick-add'))return;
     const label=[
       control.getAttribute('aria-label')||'',
       control.getAttribute('title')||'',
       control.textContent||''
     ].join(' ').slice(0,400);
     const isSaved=control.getAttribute('aria-pressed')==='true'||
       control.getAttribute('data-saved')==='true'||
       control.getAttribute('data-wishlisted')==='true'||
       savedText.test(label);
     if(control.dataset.slsWishSaved!==(isSaved?'true':'false'))control.dataset.slsWishSaved=isSaved?'true':'false';
   });
 }
 let scheduled=false;
 const schedule=()=>{
   if(scheduled)return;
   scheduled=true;
   requestAnimationFrame(()=>{scheduled=false;refresh();});
 };
 refresh();
 if(typeof MutationObserver==='function'){
   const observer=new MutationObserver(schedule);
   observer.observe(host,{subtree:true,childList:true,characterData:true,
     attributes:true,attributeFilter:['class','aria-label','aria-pressed','title','data-saved','data-wishlisted','style']});
 }
 host.addEventListener('click',()=>{requestAnimationFrame(schedule);},true);
})();